import { ComboboxPopover } from '@/components/ui/combobox/combobox-popover';
import { cn, pluralize } from '@/lib/utils';
import { type ReactNode, useMemo } from 'react';
import { useFilteredDealsContext } from '../filtered-deals/filtered-deals-provider';
import { LAST_UPDATED_DATE_FILTER_OPTIONS } from '../types';

const LastUpdatedDateFiltersComboBoxPopover = ({
  children,
  comboBoxOnChange,
  comboBoxOpen,
  onOpenChange,
  alignOffset,
  side = 'bottom',
  align,
  popoverContentClassName,
  stayOpenAfterSelection = true,
}: {
  children: ReactNode;
  comboBoxOnChange: (value: string) => void;
  comboBoxOpen: boolean;
  onOpenChange: (open: boolean) => void;
  alignOffset?: number;
  side?: 'left' | 'top' | 'right' | 'bottom' | undefined;
  align?: 'center' | 'start' | 'end' | undefined;
  popoverContentClassName?: string;
  stayOpenAfterSelection?: boolean;
}) => {
  const { getCount } = useFilteredDealsContext();
  const comboBoxOptions = useMemo(() => {
    return LAST_UPDATED_DATE_FILTER_OPTIONS.map(
      (lastUpdatedDateFilterOption) => {
        const count = getCount(
          'last_updated_date',
          lastUpdatedDateFilterOption.value,
        );

        return {
          label: (
            <div className="flex flex-row items-center gap-2 text-nowrap text-black">
              {lastUpdatedDateFilterOption.label}
              <span className="text-xs text-gray-400">
                {count} {pluralize(count, 'deal', 'deals')}
              </span>
            </div>
          ),
          value: lastUpdatedDateFilterOption.value,
        };
      },
    );
  }, [getCount]);

  return (
    <ComboboxPopover
      placeholder={'Last Updated Date...'}
      options={comboBoxOptions}
      onChange={comboBoxOnChange}
      align={align}
      side={side}
      alignOffset={alignOffset}
      // TODO: Add end adornment and empty message
      endAdornment={undefined}
      emptyMessage={undefined}
      open={comboBoxOpen}
      onOpenChange={onOpenChange}
      stayOpenAfterSelection={stayOpenAfterSelection}
      popoverContentClassName={cn(
        'w-fit min-w-[200px]',
        popoverContentClassName,
      )}
    >
      {children}
    </ComboboxPopover>
  );
};

export default LastUpdatedDateFiltersComboBoxPopover;
